import { auditFields, operations, types } from '../common';

/**
 * Entity schema
 */
const schema = {
  version: 0,

  title: 'Collection confirmation',
  description: 'Blood donation collection confirmation',

  primaryKey: 'id',
  type: 'object',
  properties: {
    id: types.ID,
    icode: types.STRING_INDEX,

    type: types.STRING_INDEX, // transport
    details: types.STRING,

    task: types.OBJECT,

    // Audit fields
    ...auditFields
  },

  required: ['id', 'type', 'task'],
  indexes: [
    ['type']
  ],
  keyCompression: true
};

/**
 * Migration strategies
 */
const migrationStrategies = {};

/**
 * Collection methods
 */
const statics = {
  /**
   * Creates new instance
   *
   * Also updates full and person names
   *
   * @param {object} data  New instance
   * @returns Promise
   */
  add: function (data) {
    return operations.add(this, data);
  },

  /**
   * Updates instance
   *
   * Also updates full and person names
   *
   * @param {object} data  Instance
   * @returns Promise
   */
  edit: function (data) {
    return operations.edit(this, data);
  },

  /**
   * Deletes instance
   *
   * @param {string} id  Instance ID
   * @returns Promise
   */
  del: function (id) {
    return operations.del(this, id);
  }
};

/**
 * Instance methods
 */
const methods = {};

/**
 * Collection definition
 */
const collection = { schema, migrationStrategies, statics, methods };

export default collection;
